import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';
import { SendBundlePayload, SendBundleResponse } from '@trade-platform/ui-shared';

@Injectable()
export class OrderSendBundleService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    // POST /orders/send-bundle — note no :id in the path; the whole selection travels in the body.
    sendBundle(payload: SendBundlePayload): Observable<SendBundleResponse> {
        return this.http.post<SendBundleResponse>(`${this.environment.api}orders/send-bundle`, {
            orderIds: payload.orderIds,
            emailSubject: payload.emailSubject,
            emailBody: payload.emailBody
        });
    }
}
